export default function () {
  return {
    barscan: ''
  }
}
